import React, { useEffect, useRef } from 'react';
import AceEditor from 'react-ace';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Languages } from 'constants/languages';
import { useFreecodeContextRun, useFreecodeContextLayout, useAppContext } from 'hooks/useContext';
import { EditorContainer, CodeContainer, SolutionButtonContainer } from './styles';
import { layouts } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { LanguageSelection } from 'components/FreecodePage/FreecodeTabs/FreecodeButtons';

export default function FreecodeEditorSolution() {
  const { ticketId } = useParams();
  const { layout } = useFreecodeContextLayout();
  const { language, setLanguage, codeSol, setCodeSol } = useFreecodeContextRun();
  const { isDarkMode } = useAppContext();

  const smallScreenRef = useRef(null);
  const editorRef = useRef(null);

  let { ticketCodeData } = useSelector((state) => state.freecode);

  useEffect(() => {
    let codeData = ticketCodeData[ticketId];
    if (!editorRef.current || !codeData?.code) return;
    setCodeSol(codeData?.code);
    if (codeData?.language && codeData?.language !== language) setLanguage(codeData.language);
    if (codeData?.fsEditorPosSol)
      editorRef.current.navigateTo(codeData.fsEditorPosSol.row, codeData.fsEditorPosSol.column);
  }, [ticketCodeData, setCodeSol, setLanguage, ticketId, language]);

  const onEditorLoad = (editor) => (editorRef.current = editor);

  const renderSmallScreenButtons = () => (
    <SolutionButtonContainer ref={smallScreenRef}>
      <LanguageSelection />
    </SolutionButtonContainer>
  );

  return (
    <EditorContainer>
      {layout === layouts.small && renderSmallScreenButtons()}
      <CodeContainer smallScreenOffset={smallScreenRef.current?.clientHeight || 0}>
        <AceEditor
          placeholder="Code"
          mode={Languages[language].EditorName}
          theme={isDarkMode ? 'monokai' : 'tomorrow'}
          fontSize={15}
          value={codeSol}
          name="liveCodingSolutionEditorId"
          onLoad={onEditorLoad}
          showPrintMargin={false}
          wrapEnabled={true}
          width={'100%'}
          height={'100%'}
          editorProps={{ $blockScrolling: true }}
          readOnly={true}
        />
      </CodeContainer>
    </EditorContainer>
  );
}
